import $ from 'jquery';
import SegmentControllerFactory from "./SegmentControllerFactory";
import DomHelper from "./../../../utils/DomHelper";
import Cookie from "./../../../utils/Cookie";
import CardList from "./CardList";
import SimulatorPPI from "./SimulatorPPI";
import PopinView from "../Popin/Popin.view";
import GlossaryController from "./Glossary/Glossary.controller";
import GlossaryTerms from "./Glossary/GlossaryTerms";

var SEGMENT_ATTR = {
    DEFAULT: "data-clientside-segments",
    BFM: "data-clientside-segments-bfm",
    PRIVATE_BANKING: "data-clientside-segments-bp",
    COOKIES: "data-clientside-cookies",
    COOKIES_EXCLUDE: "data-clientside-cookies-exclude"
};

export default {
    initialize: function () {
        const ATTR_CLIENT_ID = "data-clientside-id";
        const SEPARATOR_COMMA = ",";

        $("*[data-clientside-id]").each((index, element) => {
            // only continues with executing the function if the FunctionMapper is really defined (which should), and if there
            // really is a function for this ID
            var functionIds = $(element)
                .attr(ATTR_CLIENT_ID)
                .split(SEPARATOR_COMMA);

            functionIds.forEach(functionId => {
                if(this.has(functionId)){
                // calls the method passing the element, so the function can do whatever it need with it
                this[functionId](element);
                }
            });
        });
    },

    has: function (methodName) {
        return !!this[methodName];
    },

    // Method that analyzes if the content should be or not visible, depending on the cookie segments (include and exclude cookies)
    analyzeCookiePersonalizationVisibility: function(cookieSegments){
        var cookiesToShow = cookieSegments.get();
        var cookiesToHide = cookieSegments.getToHide();

        var shouldBeVisible = false;
        // If there are no cookies to hide set, let's analyze the cookies to show
        if(!cookiesToHide){
            shouldBeVisible = Cookie.analyze(cookiesToShow);
        } else if(!cookiesToShow){
            // If there are no cookies to show set, let's analyze the cookies to hide
            shouldBeVisible = Cookie.analyzeHide(cookiesToHide);
        } else {
            // There are both cookies to show and to hide set, so let's analyze the cookies to hide
            shouldBeVisible = Cookie.analyzeShowAndHide(cookiesToShow, cookiesToHide);
        }

        return shouldBeVisible;
    },

    /**
     * Removes the Open New Account button if the client is authenticated or recognized
     */
    openNewAccountButton: function (element) {
        var clientSegment = SegmentControllerFactory(element, SEGMENT_ATTR.DEFAULT);

        if (clientSegment.isAnyActive()) {
            clientSegment.removeElement();
        }
    },

    /**
     * Sets the secure search results link if the user is authenticated
     */
    setSecureSearchResults: function (element) {
        var clientSegment = SegmentControllerFactory(element, SEGMENT_ATTR.DEFAULT);

        if (clientSegment.isAnyActive()) {
            clientSegment.setAction("/secure/resultats-recherche");
        }
    },

    /**
     * Sets the Connected Header color for BFM, BP1 and BP2
     */
    setConnectedHeaderColor: function (element) {
        var bfmSegments = SegmentControllerFactory(element, SEGMENT_ATTR.BFM);
        var bpSegments = SegmentControllerFactory(
            element,
            SEGMENT_ATTR.PRIVATE_BANKING
        );

        if (bfmSegments.isAnyActive()) {
            bfmSegments.setHeaderBrand();
        } else if (bpSegments.isAnyActive()) {
            bpSegments.setHeaderBrand();
        }
    },

    /**
     * Applies the cookie segmentation
     */
    applyCookieSegmentation: function (element) {
        var cookieSegments = SegmentControllerFactory(element, SEGMENT_ATTR.COOKIES, SEGMENT_ATTR.COOKIES_EXCLUDE);
        var shouldBeVisible = this.analyzeCookiePersonalizationVisibility(cookieSegments);

        if (shouldBeVisible) {
            cookieSegments.showElement();
        } else {
            cookieSegments.removeElement();
        }
    },

    /**
     * Applies the cookie segmentation for Cards
     */
    applyCardsCookieSegmentation: function (element) {
        var cookieSegments = SegmentControllerFactory(element, SEGMENT_ATTR.COOKIES, SEGMENT_ATTR.COOKIES_EXCLUDE);
        var shouldBeVisible = this.analyzeCookiePersonalizationVisibility(cookieSegments);

        if (shouldBeVisible) {
            cookieSegments.showElement();
        } else {
            // if it's not meant to be shown, first analyzes if this is the last child: if it is, replaces its
            // content with a message; if it's not, removes it from the HTML
            var cardList = new CardList(element);

            if (cardList.hasExpectedChildrenIndex()) {
                cardList.showNoCardMessage();
                cookieSegments.showElement();
            } else {
                cookieSegments.removeElement();
            }
        }
    },

    /**
     * Calls the PPI Simulator
     */
    callPpiSimulator: function (element) {
        try {
            var simulatorPPI = new SimulatorPPI({
                element: element,
                sdcWrapper: "dpiWrapper",
                defaultRoute: "#dpi/simulationrapide",
                noRoute: true
            });

            if (simulatorPPI) {
                simulatorPPI.load();
            }

        } catch (errorMessage) {
            console.error(errorMessage);
        }
    },

    /**
     * Prestation Code
     * 2 cases basically usable by contributors
     * - getPrestCouranteTypeGestSousMandat
     * - getPrestCouranteTypeGestConseillee
     */
    getPrest: function (element) {
        var relatedMethod = element.getAttribute("data-clientside-method-name");
        var answer = element.getAttribute("data-clientside-answer");

        if(answer === null || answer === "" || relatedMethod === null || relatedMethod === "") {
            return false;
        }

        var answerCleaned = answer.trim().toLowerCase();

        // First case : getPrestCouranteTypeGestSousMandat
        if(relatedMethod === "getPrestCouranteTypeGestSousMandat" && typeof window.getPrestCouranteTypeGestSousMandat === "function"){
            var result = window.getPrestCouranteTypeGestSousMandat();
            generateAnchorsAttr(element, result, answerCleaned);
        }

        // Second case : getPrestCouranteTypeGestConseillee
        if(relatedMethod === "getPrestCouranteTypeGestConseillee" && typeof window.getPrestCouranteTypeGestConseillee === "function"){
            var result = window.getPrestCouranteTypeGestConseillee();
            generateAnchorsAttr(element, result, answerCleaned);
        }
    },

    /**
     * Show link in case its data-clientside-mandat attribute and the visited page hash are the same
     */
    showRequestedMandats: function (element) {
        var showElement = function (element) {
            element.style.display = "";
        };
        var getMandatTypesAsArray = function (requestedMandatTypes) {
            return requestedMandatTypes.split(/\s*,\s*/);
        };

        var requestedMandatType = window.location.hash.replace("#typeMandat=", "");

        if (!requestedMandatType) {
            showElement(element);
            return;
        }

        var mandatTypeAttribute = element.getAttribute("data-clientside-mandat");

        if (
            mandatTypeAttribute &&
            getMandatTypesAsArray(mandatTypeAttribute).indexOf(requestedMandatType) >=
            0
        ) {
            showElement(element);
        }
    },

    /**
     * Show glossary terms
     */
    applyGlossaryTerms: function (element) {
        var POPIN_ID = "dcw_popin",
            POPIN_TITLE_ID = "dcw_popin-title",
            POPIN_DESCRIPTION_ID = "dcw_popin-desc";

        var popinContainer = document.getElementById(POPIN_ID);
        var titleElement = document.getElementById(POPIN_TITLE_ID);
        var descriptionElement = document.getElementById(POPIN_DESCRIPTION_ID);

        var popinInfoView = new PopinView(
            popinContainer,
            titleElement,
            descriptionElement
        );

        GlossaryTerms.fetch(function (terms) {
            new GlossaryController(element, popinInfoView, terms);
        });
    }
};

/**
 *  This function generate anchors in all links inside of the element pass like paramater, depending of the results from external methods.
 *  The variable "answer" is coming from presentation properties
 *  The variable result is coming from the external method
 *  Params : element, result, answer
 */
function generateAnchorsAttr(element, result, answer) {
    // if the result from current method is defined and contains the expected answer
    if (result != undefined && result.typeGestion != undefined && result.typeGestion.trim().toLowerCase() === answer) {
        // begins to set the links (it sets all the links below the element)
        if (result.idPrest !== undefined && result.idPrest.toLowerCase() !== "impossible a definir") {
            var anchorChildren = element.getElementsByTagName("a");

            for (var i = 0, nbAnchors = anchorChildren.length; i < nbAnchors; i++) {
                var anchorElem = anchorChildren[i];
                var anchorElemHref = anchorElem.getAttribute("href");

                if (anchorElemHref !== undefined && anchorElemHref !== "") {
                    anchorElem.setAttribute("href", anchorElemHref + result.idPrest);
                }
            }
        }

        // shows the element
        DomHelper.unwrap(element);
    }
}


// WEBPACK FOOTER //
// ./src/js/cms/commons/clientCustomizer/ClientCustomizer.js